export default __webpack_public_path__ + "static/media/flow-chart.51c2530e.png";